exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-row[data-v-1466aa5d]{min-height:170px}.report-header[data-v-1466aa5d]{max-width:100%}", ""]);

// exports
